<form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>


  <div class="modal-body">
    <!-- row -->
    <div class="row">

      <div class="col-md-12">

        <!-- tile -->
        <section class="tile tile-simple">

          <!-- tile body -->
          <div class="tile-body p-0">

            <div role="tabpanel">


              <!-- Tab panes -->
              <div class="tab-content">

                <div role="tabpanel" class="tab-pane active" id="generalTab">

                  <div class="wrap-reset">

                    <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
                      <div *ngFor="let validation of msg">
                        <div class="error-message"
                          *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
                          {{validation.message}}
                        </div>
                      </div>
                    </ng-template>



                    <div class="row">

                      <div class="form-group col-sm-6">
                        <label for="first-name">Course Code</label>
                        <input type="text" class="form-control" formControlName="course_code"
                          [ngClass]="formErrorClass(createForm.controls.course_code, createFormSubmitted)">
                      </div>

                      <div class="form-group col-sm-6">
                        <label>Status of the course</label>
                        <div>
                          <label class="checkbox-inline checkbox-custom-alt">
                            <input type="radio" formControlName="course_status" value="1"
                              [ngClass]="formErrorClass (createForm.controls.course_status, createFormSubmitted)"><i></i>
                            OPEN
                          </label>
                          <label class="checkbox-inline checkbox-custom-alt">
                            <input type="radio" formControlName="course_status" value="2"
                              [ngClass]="formErrorClass (createForm.controls.course_status, createFormSubmitted)"><i></i>CLOSED
                          </label>

                          <label class="checkbox-inline checkbox-custom-alt">
                            <input type="radio" formControlName="course_status" value="0"
                              [ngClass]="formErrorClass (createForm.controls.course_status, createFormSubmitted)"><i></i>SUSPENDED
                          </label>

                        </div>
                      </div><br><br><br><br>


                      <div class="form-group col-sm-6">
                        <label for="first-name">Course Type</label>
                        <select class="form-control" formControlName="course_type"
                          [ngClass]="formErrorClass (createForm.controls.course_type, createFormSubmitted)">
                          <option value="">Please Select</option>
                          <option *ngFor="let type of courseType" [ngValue]="type.value">{{type.text}}</option>
                        </select>
                      </div>


                      <div class="form-group col-sm-6">
                        <label for="first-name">Course Name</label>
                        <input type="text" class="form-control" formControlName="course_name"
                          [ngClass]="formErrorClass(createForm.controls.course_name, createFormSubmitted)">

                      </div>



                      <div class="form-group col-sm-6">
                        <label for="first-name">Cost</label>
                        <input type="text" class="form-control" formControlName="course_cost"
                          [ngClass]="formErrorClass(createForm.controls.course_cost, createFormSubmitted)">
                      </div>

                      <div class="form-group col-sm-6">
                        <label for="first-name">Duration (Hours)</label>
                        <input type="text" class="form-control" formControlName="course_hours"
                          [ngClass]="formErrorClass(createForm.controls.course_hours, createFormSubmitted)">

                      </div>


                      <div class="form-group col-sm-6">
                        <label for="first-name">Topic</label>
                        <textarea class="form-control" formControlName="course_treatment"
                          [ngClass]="formErrorClass(createForm.controls.course_treatment, createFormSubmitted)"></textarea>

                      </div>

                      <div class="form-group col-sm-6">
                        <label for="first-name">Available Skills</label>
                        <!-- <input type="text" class="form-control" formControlName="course_available_skills"
              [ngClass]="formErrorClass(createForm.controls.course_available_skills, createFormSubmitted)"> -->


                        <ng-multiselect-dropdown formControlName="course_available_skills" [data]="skills_places"
                          [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>


                      </div><br><br><br><br><br><br><br><br><br><br><br><br><br>

                      <div class="form-group col-sm-6">
                        <label for="first-name">Responsible</label>
                        <input type="text" class="form-control" formControlName="course_resp"
                          [ngClass]="formErrorClass(createForm.controls.course_resp, createFormSubmitted)">
                      </div>

                      <div class="form-group col-sm-6">
                        <label for="first-name">Place</label>
                        <input type="text" class="form-control" formControlName="course_hop"
                          [ngClass]="formErrorClass(createForm.controls.course_hop, createFormSubmitted)">

                      </div>

                      <div class="form-group col-sm-6">
                        <label for="first-name">Start Date</label>
                        <input type="date" class="form-control" formControlName="course_start_date"
                          [ngClass]="formErrorClass(createForm.controls.course_start_date, createFormSubmitted)">
                      </div>

                      <div class="form-group col-sm-6">
                        <label for="first-name">End Date</label>
                        <input type="date" class="form-control" formControlName="course_end_date"
                          [ngClass]="formErrorClass(createForm.controls.course_end_date, createFormSubmitted)">

                      </div>

                      <!-- <div class="form-group col-sm-6">
            <label for="first-name">Teaching Materials</label>
            <input type="text" class="form-control" formControlName="type"
              [ngClass]="formErrorClass(createForm.controls.type, createFormSubmitted)">
          </div> -->
                      <div class="col-sm-6" >

                        <div formArrayName="fileupload">
                          <label>Teaching Materials</label>
                          <div class="form-group row" *ngFor="let link of createForm.get('fileupload')?.controls; let i = index;"
                            [formGroupName]="i">
                            <div class="col-sm-12">
                              <input type="file" class="filestyle" data-buttonText="Choose file"
                                (change)="selectAttachment($event,i)" formControlName="link">
                            </div>
  
                          </div>
                        </div>
                        
                        <div class="form-group col-sm-12" formArrayName="service_image_uploaded">

                          <div class="form-group row"
                            *ngFor="let image of service_image_uploaded().controls; let i=index">
                            <div class="col-sm-8">
                              <input type="hidden" class="form-control" formControlName="{{i}}">
                              <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">
  
                              <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/course_material/{{image.value.split('/').pop()}}"
                                target="_blank">{{image.value.split('/').pop()}}</a>
  
                            </div>
                            <div class="col-sm-4">
                              <button class="btn btn-primary pull-right" type="button"
                                (click)="removeAttachmentUploaded1(i)">
                                <i class="fa fa-trash-o"></i>
                              </button>
                            </div>
                          </div>
                        </div>   
  
                      </div>

                   

                      <div class="col-sm-6" formArrayName="send_email">
                        <label>Teacher</label>
                        <div class="form-group row" *ngFor="let email of send_email().controls; let i=index">
                          <div class="col-sm-11">
                            <input type="text" class="form-control" formControlName="{{i}}"
                              [ngClass]="formErrorClass(send_email().controls[i], createFormSubmitted)">

                          </div>
                          <div class="col-sm-1">
                            <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)"
                              *ngIf=" i!=(send_email().controls.length-1) ">
                              <i class="fa fa-trash-o"></i>
                            </button>
                            <button class="btn btn-primary pull-right" type="button" (click)="addEmail()"
                              *ngIf=" i==(send_email().controls.length-1) ">
                              <i class="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div><br><br><br><br><br><br><br><br><br><br><br><br>


                    </div>



                  </div>

                </div>



              </div>

            </div>

          </div>
          <!-- /tile body -->

        </section>
        <!-- /tile -->

      </div>


    </div>
    <!-- /page content -->
  </div>


  <div class="modal-footer">

    <button type="submit" class="btn btn-primary">Save</button>
    <button type="button" class="btn btn-success" (click)="closeModal()">Close</button>
  </div>

</form>